import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Card, Col, Row, Tabs, Divider} from "antd";

import AppNotificationContainer from "../../components/AppNotificationContainer";
import ListPackets from "./ListPackets";
import AddPacket from "./AddPacket";
import AddGroup from "./AddGroup";
import ListGroups from "./ListGroups";
import AddChannel from "./AddChannel";
import ListChannels from "./ListChannels";
import {getGroups} from "../../appRedux/actions/PacketGroup";
import AddCountry from "./AddCountry";
import ListCountry from "./ListCountry";
import IntlMessages from "../../util/IntlMessages";
import {getCountry} from "../../appRedux/actions/PacketCountry";
import {getChannels} from "../../appRedux/actions";
import {getPackets} from "../../appRedux/actions/Packet";

const PacketsComponent = () => {

    const { authUser } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('1');

    useEffect(() => {
        const actions = {
            '1': getPackets,
            '2': getGroups,
            '3': getCountry,
            '4': getChannels
        };

        if (actions[activeTab]) {
            dispatch(actions[activeTab]());
        }
    }, [activeTab, dispatch]);

    const tabItems = [
        {
            key: '1',
            label: 'Packet',
            children: (
                <Row>
                    {authUser.is_staff && (
                        <Col span={24}>
                            <div className="gx-layout-footer-content gx-mb-2">
                                <IntlMessages id="packet.indexApp.createPacket"/>
                            </div>
                            <AddPacket/>
                            <Divider style={{ backgroundColor: '#fafafa' }}/>
                        </Col>
                    )}
                    <Col span={24}>
                        <div className="gx-layout-footer-content gx-mb-2">
                            <IntlMessages id="packet.indexApp.listPackets"/>
                        </div>
                        <ListPackets/>
                    </Col>
                </Row>
            )
        },
        {
            key: '2',
            label: 'Group',
            children: (
                <Row>
                    {authUser.is_superuser && (
                        <Col span={24}>
                            <div className="gx-layout-footer-content gx-mb-2">
                                <IntlMessages id="packet.indexApp.createGroup"/>
                            </div>
                            <AddGroup/>
                            <Divider style={{ backgroundColor: '#fafafa' }}/>
                        </Col>
                    )}
                    <Col span={24}>
                        <div className="gx-layout-footer-content gx-mb-2">
                            <IntlMessages id="packet.indexApp.listGroups"/>
                        </div>
                        <ListGroups/>
                    </Col>
                </Row>
            )
        },
        {
            key: '3',
            label: 'Country',
            children: (
                <Row>
                    {authUser.is_superuser && (
                        <Col span={24}>
                            <div className="gx-layout-footer-content gx-mb-2">
                                <IntlMessages id="packet.indexApp.createCountry"/>
                            </div>
                            <AddCountry/>
                            <Divider style={{ backgroundColor: '#fafafa' }}/>
                        </Col>
                    )}
                    <Col span={24}>
                        <div className="gx-layout-footer-content gx-mb-2">
                            <IntlMessages id="packet.indexApp.listCountries"/>
                        </div>
                        <ListCountry/>
                    </Col>
                </Row>
            )
        },
        {
            key: '4',
            label: 'Channel',
            children: (
                <Row>
                    {authUser.is_superuser && (
                        <Col span={24}>
                            <div className="gx-layout-footer-content gx-mb-2">
                                <IntlMessages id="packet.indexApp.createChannel"/>
                            </div>
                            <AddChannel/>
                            <Divider style={{ backgroundColor: '#fafafa' }}/>
                        </Col>
                    )}
                    <Col span={24}>
                        <div className="gx-layout-footer-content gx-mb-2">
                            <IntlMessages id="packet.indexApp.listChannels"/>
                        </div>
                        <ListChannels/>
                    </Col>
                </Row>
            )
        }
    ];

    return (
        <Card className="gx-card">
            <Tabs
                defaultActiveKey="1"
                activeKey={activeTab}
                items={tabItems}
                onChange={setActiveTab}
            />
            <AppNotificationContainer/>
        </Card>
    );
};

export default PacketsComponent;
